var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.255859,
    width: 41.4887,
    height: 41.4887,
    rx: 18.3003,
    fill: "#6FBE45",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 16.7987C13.9961 16.4915 14.1626 16.2085 14.4311 16.0593L20.3516 12.7702C20.6071 12.6283 20.9177 12.6283 21.1731 12.7702L27.0936 16.0593C27.3621 16.2085 27.5286 16.4915 27.5286 16.7987V20.722C27.5286 23.7936 25.8634 26.6238 23.1783 28.1155L21.1731 29.2295C20.9177 29.3714 20.6071 29.3714 20.3516 29.2295L18.3464 28.1155C15.6614 26.6238 13.9961 23.7936 13.9961 20.722V16.7987Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.5d7901cd4976e1d2451dbabb76462c49.svg";
export { ForwardRef as ReactComponent };